import React from 'react';
import { HeroVariant72 } from '../components/HeroVariant72';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage72() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1786">
      <Navigation data-id="element-1787" />
      <main data-id="element-1788">
        <HeroVariant72 data-id="element-1789" />
        <WhyUs data-id="element-1790" />
        <Services data-id="element-1791" />
        <FAQ data-id="element-1792" />
        <Testimonials data-id="element-1793" />
        <Consultation data-id="element-1794" />
      </main>
      <Footer data-id="element-1795" />
      <CookieBanner data-id="element-1796" />
      <FloatingContact data-id="element-1797" />
    </div>;
}